<template>
  <DrupalLink :to="url" class="block">
    <MediaImage v-if="image" v-bind="image" :style-name="styleName" />
    <div class="is-3 group-hover:opacity-60 mt-15">
      {{ title }}
    </div>
  </DrupalLink>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'
import type { LegacyImageStyle } from '~/helpers/imageStyles'

withDefaults(
  defineProps<{
    title: string
    url: string
    image?: MediaImageFragment
    styleName?: LegacyImageStyle
  }>(),
  {
    styleName: 'teaser_one',
    image: undefined,
  },
)
</script>
